/**
 * Created by shanie on 6/26/17.
 */

let AddToFolderModal;

export default {
    loadPortfolioModal(cb) {
        if (AddToFolderModal) {
            cb(AddToFolderModal);
        } else {
            require.ensure(
                ['dibs-portfolio-folder/src/components/AddToFolderModalWrapper'],
                () => {
                    AddToFolderModal = require('dibs-portfolio-folder/src/components/AddToFolderModalWrapper')
                        .default;
                    cb(AddToFolderModal);
                },
                null,
                'miscAsyncPorfolioModalLoader'
            );
        }
    },
};
